import { InfoWindow } from '@react-google-maps/api'
import React from 'react'
import { VendorFragment } from '../../src/model/fragments'
import { VendorCard } from './VendorCard'

export interface VendorInfoWindowProps {
	place?: VendorFragment
	onClose: () => void
}
export const VendorInfoWindow: React.FC<VendorInfoWindowProps> = ({
	place,
	onClose,
}) => {
	if (!place) {
		return null
	}

	return (
		<InfoWindow
			position={{
				lat: place.gpsLat!,
				lng: place.gpsLng!,
			}}
			onCloseClick={onClose}
			options={{
				pixelOffset: new google.maps.Size(0, -60),
				disableAutoPan: true,
			}}
		>
			<VendorCard place={place} onDismiss={onClose} />
		</InfoWindow>
	)
}
